import { CircularProgress } from "@mui/material";
import { ReactComponent as LoadingSpinner } from "./spinner.svg";
function LoadingSpinnerImg(props) {
  return (<div style={{width:'100%', display:'flex',justifyContent:'center', marginTop:props?.marginTop !== undefined? props.marginTop : 40}}><CircularProgress size={props?.size ? props.size: 100}/></div>);
}

export default LoadingSpinnerImg;
